'use client';

/* empty css                             */
var defaultTitleFontFamily = "Poppins";
var titleFontVars = { fontFamily: "var(--c5-21-2_y171sh0)" };
var titleFontThemes = { sourceSans: "c5-21-2_y171sh1", notoSerif: "c5-21-2_y171sh2", lato: "c5-21-2_y171sh3", montserrat: "c5-21-2_y171sh4", openSans: "c5-21-2_y171sh5", raleway: "c5-21-2_y171sh6" };
export {
  defaultTitleFontFamily,
  titleFontThemes,
  titleFontVars
};
